import styled from 'styled-components';
import { Link as DefLink } from 'gatsby';

import { fonts } from '@/theme';

export default styled(DefLink)`
  ${fonts.link}
`;
